import { clientApi } from '../../configuration';
import getCRUDHooks from '../../utils/services/getCRUDHooks';

const { useDelete: useAssessmentDeletion } = getCRUDHooks({
  entityName: 'assessments',
  sharedCacheEntities: ['juryAssessmentsList'],
  remove: ({ id }: { id: number }) =>
    clientApi.getOCClient().helpers.learningActivity.assessments.delete(id),
});

// eslint-disable-next-line import/prefer-default-export
export { useAssessmentDeletion };
